import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = {
    user: {},
    store: {},
};

const userSlice = createSlice({
    name: "user",
    initialState: initialStateValue,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setStore: (state, action) => {
            state.store = action.payload;
        },
    },
});

export const { setUser, setStore } = userSlice.actions;

export default userSlice.reducer;
